import axios from "axios";
import { makeAutoObservable, toJS } from "mobx";
import Tool from "../pages/ROI/Tool";
import ToolStore from "./ToolStore";

class TimeSpentStore {
  defaultsValues = {};
  data = {};
  changed = {};
  reset() {
    this.defaultsValues = {};
    this.data = {};
    this.changed = {};
  }
  constructor() {
    makeAutoObservable(this);
  }

  setDefaultsValues() {
    this.defaultsValues = this.toFormatJson();
  }
  getData() {
    return toJS(this.data);
  }

  setData(values) {
    this.data = values;
  }
  setChanged(values) {
    this.changed = values;
  }

  setChangedFirst(values) {
    this.changed = values;
  }
  toFormatChanged() {
    var json = {};
    toJS(this.data)[0].value.forEach((x) => {
      if (Array.isArray(x.value)) {
        x.value.forEach((y) => {
          if (Array.isArray(y.value)) {
            y.value.forEach((z) => {
              json["" + y.fieldName + z.fieldName] = false;
            });
          } else {
            json[x.fieldName + "" + y.fieldName] = false;
          }
        });
      } else {
        json[x.fieldName] = false;
      }
    });

    return json;
  }
  toFormatJson() {
    var json = {};
    toJS(this.data)[0].value.forEach((x) => {
      if (Array.isArray(x.value)) {
        x.value.forEach((y) => {
          if (Array.isArray(y.value)) {
            y.value.forEach((z) => {
              json["" + y.fieldName + z.fieldName] = z.value;
            });
          } else {
            json[x.fieldName + "" + y.fieldName] = y.value;
          }
        });
      } else {
        json[x.fieldName] = x.value;
      }
    });

    return json;
  }
  toUpdateTimeSpent(newValues) {
    const selected = toJS(this.data)[0];
    if (newValues.hasOwnProperty("doctorTimeSpent")) {
      selected.value[0].value = newValues["doctorTimeSpent"];
    }
    selected.value
      .filter((e) => e.fieldName == "staffTimeSpent")[0]
      .value.filter((x) => {
        if (
          x.fieldName == "dentalAssistant" &&
          newValues.hasOwnProperty("staffTimeSpentdentalAssistant")
        ) {
          x.value = newValues["staffTimeSpentdentalAssistant"];
          x.changed = true;
        }
        if (
          x.fieldName == "treatmentCoordinator" &&
          newValues.hasOwnProperty("staffTimeSpenttreatmentCoordinator")
        ) {
          x.value = newValues["staffTimeSpenttreatmentCoordinator"];
          x.changed = true;
        }
        if (
          x.fieldName == "frontDesk" &&
          newValues.hasOwnProperty("staffTimeSpentfrontDesk")
        ) {
          x.value = newValues["staffTimeSpentfrontDesk"];
          x.changed = true;
        }
      });
    this.data[0] = selected;
    this.toUpdateParent();
  }

  toUpdateParent() {
    ToolStore.toUpdate("timeSpentOnTheExam", this.getData());
  }
}

export default new TimeSpentStore();
